import { priceListAddToCart } from 'redux/actions/cartActions'

export const addOrIncrementServiceInCart = async (dispatch, cart, service) => {
  const idx = cart.findIndex(c => c.ProductId === service.productId)

  if (idx === -1) {
    return dispatch(priceListAddToCart([service]))
  }

  const item = cart[idx]
  const [intPart, decPart] = item.Quantity.toString().split('.')
  const newQty = decPart
    ? `${parseInt(intPart) + 1}.${decPart}`
    : `${parseInt(intPart) + 1}`

  return dispatch(
    priceListAddToCart([
      {
        ...item,
        Quantity: newQty,
        qty: newQty,
      },
    ])
  )
}
